// extracted by mini-css-extract-plugin
export default {"container":"DataTable_container__jBNMl","isLoading":"DataTable_isLoading__8SFOg"};